<div class="ix-shell">
  <div
    role="dialog"
    class="ix-shell__release-banner"
    aria-label="Release warning dialog"
    [class.visible]="isBannerVisible()"
  >
    @if (bannerToShow(); as banner) {
      <app-release-banner [banner]="banner" (dismissBanner)="onDismissBanner($event)"></app-release-banner>
    }
  </div>

  <app-top-navigation class="ix-shell__top-nav" />
  <div class="flex">
    <app-side-navigation />
    <div class="ix-shell__content" [class.nav-collapsed]="isSideNavCollapsed()">
      @if (!isLoading()) {
        <router-outlet />
      } @else {
        <div class="flex__center loader">
          <app-loader [size]="32" />
        </div>
      }
    </div>
  </div>
</div>
